import { Modal } from "@/components";
import {
  countDecimals,
  CREATE_TYPE,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  EDIT_TYPE,
  handleMessagesAPI,
  isInteger,
  isNumeric,
  OBJECT_TYPES,
  OBJECT_TYPE_CMC,
  OBJECT_TYPE_GDC,
  REMOVE_TYPE,
} from "@/utils";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "GeneralConfigurationModal",
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  components: { Modal },
  data() {
    return {
      formRQ: this.$form.createForm(this, { name: "editGeneralConfiguration", onValuesChange: this.onValuesChange }),
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
        layout: "horizontal",
      },
      isDisabled: false,
      loading: false,
      EDIT_TYPE,
      REMOVE_TYPE,
      OBJECT_TYPES,
      OBJECT_TYPE_CMC,
      OBJECT_TYPE_GDC,
      formData: {},
      isObjectCMC: true,
      DATE_FORMAT_V2,
    };
  },
  watch: {
    computeProps() {
      if (this.visibleModal) {
        this.handleInitFormData();
      }
    },
  },
  computed: {
    ...mapState({
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
      timeServer: (state) => state.application.timeServer,
    }),
    generateTitle() {
      switch (this.type) {
        case CREATE_TYPE:
          return "Add General Configuration";
        case EDIT_TYPE:
          return "Edit General Configuration";
        case REMOVE_TYPE:
          return "Please Confirm";
        default:
          return "Add General Configuration";
      }
    },
    computeProps() {
      const { type, data } = this;
      return { type, data };
    },
  },
  created() {
    this.$store.dispatch("advance/getMostRecentTimeSheetApproved");

    // Handle Init Form Data
    if (this.visibleModal) {
      this.handleInitFormData();
    }
  },
  methods: {
    handleInitFormData() {
      const { type, data } = this;
      if (type === EDIT_TYPE) {
        if (!data) return;
        const {
          applyDate,
          expireDate,
          seniorityLeaveHour,
          seniorityLeaveYear,
          leaveHourInMonth,
          conditionalMonth,
          advanceLeave,
        } = data;
        this.formData = {
          object_type: OBJECT_TYPE_CMC,
          seniorityLeaveHour,
          seniorityLeaveYear,
          leaveHourInMonth,
          conditionalMonth,
          advanceLeave,
          applyDate: moment(applyDate, DATE_FORMAT_V2_FULL),
          expireDate: moment(expireDate, DATE_FORMAT_V2_FULL),
        };
        if (
          moment(applyDate, DATE_FORMAT_V2_FULL).isSameOrBefore(
            moment(this.mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL)
          )
        ) {
          this.disabledFieldEdit = true;
        }
      } else if (type === CREATE_TYPE) {
        this.formData = {
          ...this.formData,
          object_type: OBJECT_TYPE_CMC,
        };
      }
    },
    onValuesChange(_, values) {
      const { object_type } = values;
      if (object_type) {
        this.isObjectCMC = object_type === OBJECT_TYPE_CMC;
      }
    },
    handleFormatNumVal(val) {
      if (val) {
        val = val.toFixed(2);
      }

      return val;
    },

    onChangeStaff(value) {
      this.form.staff = value;
    },

    // handleValidation(rule, value, callback, field, validateParams = {}) {
    //   if (!value) {
    //     callback();
    //   }

    //   if (validateParams.type !== "dateTime") {
    //     const isDecimal = validateParams.isDecimal;
    //     if (!isValidValue(value) || (validateParams.type == "numeric" && !isNumberValue(value, isDecimal))) {
    //       callback(`${field} is invalid`);
    //     }
    //   }
    //   switch (field) {
    //     case "Advance payment leave":
    //     case "Annual day/Month":
    //     case "Condition/Month":
    //     case "Seniority day":
    //     case "Seniority year":
    //       this.handleRangeVal(rule, value, callback, field, validateParams);
    //       break;
    //     default:
    //       break;
    //   }
    //   callback();
    // },
    handleValidation(rule, value, callback, field, validateParams) {
      // let formatVal = null;
      // if (isDecimal) {
      //   formatVal = parseFloat(value);
      // } else {
      //   formatVal = parseInt(value);
      // }
      if (value) {
        const { from, to, isDecimal } = validateParams;
        if (!isNumeric(value)) {
          callback(`${field} is valid`);
        }
        if (!isDecimal && !isInteger(value)) {
          callback(`${field} is integer`);
        }
        const formatNumber = Number(value);

        if (formatNumber < from || formatNumber > to) {
          callback(`${field} in range ${from}-${to}`);
        }
        if (isDecimal && countDecimals(formatNumber) > 2) {
          callback("Invalid duration (ex: 0.50, 1.00 , 1.50, 2.10, ...) ");
        }
      }
      callback();
    },

    handleDisabledApplyDate(date) {
      const expiredDate = this.formRQ.getFieldValue("expireDate");
      return (
        (expiredDate && moment(date).isAfter(moment(expiredDate).endOf("day"))) ||
        moment(date).isBefore(moment(this.timeServer, DATE_FORMAT_V2).add(1, "days"))
      );
    },

    handleDisabledExpiredDate(date) {
      const applyDate = this.formRQ.getFieldValue("applyDate");
      return (
        (applyDate && moment(date).isBefore(moment(applyDate, DATE_FORMAT_V2))) ||
        moment(date).isBefore(moment(this.timeServer, DATE_FORMAT_V2))
      );
    },
    onCancel(isSaveRecordSuccess = false) {
      this.formRQ.resetFields();
      this.formData = {};
      this.$emit("onCancel", isSaveRecordSuccess);
    },
    onOk() {
      this.formRQ.validateFields(async (error, values) => {
        if (error) return;
        const { type, data } = this;
        const { applyDate, expireDate, ...payload } = values;
        payload.applyDate = moment(applyDate).format(DATE_FORMAT_V2_FULL);
        payload.expireDate = moment(expireDate).format(DATE_FORMAT_V2_FULL);
        if (type === EDIT_TYPE) {
          payload.id = data?.id;
        }
        this.loading = true;
        const url = `generalConfiguration/${type === EDIT_TYPE ? "updateGeneralConfig" : type === REMOVE_TYPE ? "deleteGeneralConfig" : "createGeneralConfig"}`
        try {
          const result = await this.$store.dispatch(
            url,
            type === REMOVE_TYPE ? data?.id : payload
          );
          handleMessagesAPI(result);
          const { code } = result;
          if (code == 200) {
            this.onCancel(true);
          }
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
